import React, { FC } from "react"
import { Button, ButtonProps } from "dash-styled"

export const TabButton: FC<ButtonProps & { active: boolean }> = ({
    className,
    active,
    children,
    ...props
}) => {
    return (
        <Button
            color="plain"
            variant="contained2"
            size="xs"
            className={`justify-center shadow-none ${
                active
                    ? "font-semibold text-grape-500 bg-white"
                    : "text-rhino-450"
            } ${className ?? ""}`}
            {...props}
        >
            {children}
        </Button>
    )
}
